var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 0.267334C7.24316 0.267334 3.13241 3.03601 1.19141 7.04996H22.8099C20.869 3.03601 16.7582 0.267334 12.0007 0.267334Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 24.2687C7.24316 24.2687 3.13241 21.5 1.19141 17.4861H22.8099C20.869 21.5 16.7582 24.2687 12.0007 24.2687Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4333 8.61499H0.566672C0.199078 9.76666 0 10.9936 0 12.2672C0 13.5407 0.199078 14.7677 0.566672 15.9193H23.4333C23.8009 14.7677 24 13.5407 24 12.2672C24 10.9936 23.8009 9.76666 23.4333 8.61499Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7369 5.81388L14.3158 5.15796L12.0003 10.401L9.68478 5.15796L8.26367 5.81388L11.1384 12.2685L8.26367 18.7232L9.68478 19.3791L12.0003 14.1361L14.3158 19.3791L15.7369 18.7232L12.8622 12.2685L15.7369 5.81388Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9656 6.43226C12.4154 5.83146 12.0004 5.48608 12.0004 5.48608C12.0004 5.48608 11.5853 5.83141 11.0352 6.43226V18.1051C11.5853 18.706 12.0004 19.0513 12.0004 19.0513C12.0004 19.0513 12.4154 18.706 12.9656 18.1051V6.43226Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39258 8.67021V15.8661C9.97392 16.8962 10.6854 17.7405 11.2187 18.3002V6.23608C10.6854 6.79582 9.97387 7.64018 9.39258 8.67021Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6093 8.67021C14.0279 7.64013 13.3165 6.79582 12.7832 6.23608V18.3002C13.3164 17.7405 14.0279 16.8962 14.6093 15.8661V8.67021Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6094 8.66968V15.8656C15.1979 14.8226 15.6529 13.5894 15.6529 12.2677C15.6529 10.9459 15.1979 9.71265 14.6094 8.66968Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39114 8.66968V15.8656C8.80263 14.8226 8.34766 13.5894 8.34766 12.2677C8.34766 10.9459 8.80263 9.71265 9.39114 8.66968Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/KES.813590708afcefe072d10662e22fe479.svg";